const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the Workshop Instance Host component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('workshopInstanceHost', ['Application', 'Authorization', 'WorkshopInstances', 'UserWorkshops', 'Workshops', 'Categories', 'ZoomIntegrate', '$translate', function (Application, Authorization, WorkshopInstances, UserWorkshops, Workshops, Categories, ZoomIntegrate, $translate) {
  return {
    restrict: 'E',
    scope: {
      workshop: '=',
      instance: '=',
      allowReturn: '=',
      updateTotals: '&',
      triggerAdd: '=?',
      triggerWait: '=?',
      tab: '=?'
    },
    template: require('../../templates/directives/workshop-instance-host.html'),
    controller: ['$scope', function ($scope) {
      var self = this;

      var TableComms = function(info) {
        info.query = info.query || {};
        this.query = Object.assign({
          page: 1,
          per_page: 50,
          fields: 'user,active_status',
          'user-populate': 'first_name,last_name,full_name,image,email,linked_locations,linked_departments'
        }, info.query);
        this.originalQuery = this.query;
        this.loading = false;
        this.list = [];
        this.nextAvailable = false;
        this.status = 'uninitialized';
        this.searching = false;
        this.sortTerm = '';
        this.sortDirection = '1';
      };
      self.allSelected = false;

      self.translations = {};

      self.preview = {
        'isActive': false,
        'body': '',
        'showButton': false,
        'isCentered': false
      };

      self.statusToSet = null;
      self.registrationStatusActions = [];
      self.registrationStatuses = {};

      TableComms.prototype.resetQuery = function(query) {
        this.query = Object.assign(this.originalQuery, query);
        this.originalQuery = this.query;
        this.status = 'uninitialized';
        this.searching = false;
      };

      TableComms.prototype.onData = function(data) {
        this.status = 'loaded';
        this.nextAvailable = false;
        if (data.length === 0 && this.query.page > 1) {
          this.query.page--;
          this.loading = false;
          return;
        }
        if (data.length >= this.query.per_page) {
          this.nextAvailable = true;
        }
        this.list = data;
        this.loading = false;
      };

      TableComms.prototype.load = function(activeStatus) {
        var self = this;
        if (!this.query.workshop_instance) {
          return;
        }

        this.loading = true;

        if (!this.searching) {
          UserWorkshops.find(this.query).$promise
          .then(function(data) {
            self.onData(data);
          }).catch(function(error) {
            // handle error with messaging
            self.loading = false;
            console.log('error in loading UserWorkshops: ', error);
          });
          return;
        }

        delete this.searchQuery.page;
        delete this.searchQuery.per_page;

        var body = {reply: 'userWorkshops', status: this.activeStatus, usersQuery: this.searchQuery, userWorkshopsQuery: this.query};

        UserWorkshops.searchUsers({useropt: $scope.instance._id}, body).$promise
        .then(function(data) {
          self.onData(data);
        }).catch(function(error) {
          // handle error with messaging
          self.loading = false;
          console.log('error in loading UserWorkshops: ', error);
        });
      };

      TableComms.prototype.next = function() {
        if (!this.nextAvailable) {
          return;
        }
        this.query.page++;
        this.load();
      };

      TableComms.prototype.previous = function() {
        if (this.query.page <= 1) {
          return;
        }
        this.query.page--;
        this.load();
      };

      TableComms.prototype.search = function(query, status) {
        query = query || {};
        if (!Object.keys(query).length) {
          this.searching = false;
          this.resetQuery();
          this.load();
          return;
        }

        this.searching = true;
        this.query.page = 1;
        this.searchQuery = query;
        this.activeStatus = status;
        this.load();
      };

      TableComms.prototype.changeSort = function(type) {
        if (this.sortTerm === type) {
          this.sortDirection = this.sortDirection > 0 ? -1 : 1;
        }
        this.sortTerm = type;
        this.query.sort = this.sortTerm + ',' + this.sortDirection;
        this.load();
      };

      var TableData = function(activeStatus) {
        this.active_status = activeStatus;
        this.selections = [];
        this.selectedItems = {};
      };

      TableData.prototype.init = function(instance) {
        this.comms = new TableComms({query: {
            workshop_instance: instance,
            active_status: this.active_status
          }
        });
      };

      TableData.prototype.displayClick = function() {
        if (!this.comms) {
          if (!$scope.instance || !$scope.instance._id) {
            return;
          }
          this.init($scope.instance._id);
          this.comms.load();
          return;
        }
        if (this.comms.status === 'loaded') {
          return;
        }
        if (this.comms.status === 'uninitialized') {
          this.comms.load();
          return;
        }
      };

      TableData.prototype.queryChange = function(query) {
        if (this.comms) {
          this.comms.resetQuery(query);
        }
      };

      TableData.prototype.toggleSelect = function(item) {
        if (!item || !item.user || !item.user._id) {
          return;
        }
        const index = this.selections.indexOf(item.user._id);
        if (index !== -1) {
          this.deselect(item)
          return;
        }
        this.select(item);
      };

      TableData.prototype.select = function(item) {
        if (!this.selections.includes(item.user._id)) {
          this.selections.push(item.user._id);
          this.selectedItems[item.user._id] = item;
        }
      };

      TableData.prototype.deselect = function(item) {
        self.allSelected = false;
        const index = this.selections.indexOf(item.user._id);
        this.selections.splice(index, 1);
        this.selectedItems[item.user._id] = null;
      };

      TableData.prototype.selectAll = function() {
        self.allSelected = true;
        for (const item of this.comms.list) {
          this.select(item);
        }
      };

      TableData.prototype.deselectAll = function() {
        self.allSelected = false;
        this.selections = [];
        this.selectedItems = {};
      };

      self.applyFroalaConfigs = function(FroalaEditor) {
        // Define toolbar options
        FroalaEditor.DefineIcon('workshopDropIcon', {NAME: 'shoptag', template: 'continu_froala_replacement'});
        FroalaEditor.RegisterCommand('workshop_options', {
          title: 'Workshop Options',
          type: 'dropdown',
          icon: 'workshopDropIcon',
          focus: false,
          undo: false,
          refreshAfterCallback: true,
          options: {
            'recipient_first_name': 'Recipient First Name',
            'recipient_last_name': 'Recipient Last Name',
            'sender_first_name': 'Sender First Name',
            'sender_last_name': 'Sender Last Name',
            'workshop_title': 'Workshop Title',
            'workshop_start_date': 'Workshop Start Date',
            'workshop_start_time': 'Workshop Start Time',
            'workshop_end_date': 'Workshop End Date',
            'workshop_end_time': 'Workshop End Time',
            'workshop_location': 'Workshop Location',
            'host_name': 'Host Name'
          },
          callback: function (cmd, val) {
            this.html.insert('{' + val + '}');
          }
        });
      }

      self.recordingOpts = {
        recordings: [],
        show: false,
        deleteConfirmation: false,
        loading: false,
        selected: 0,
        select: function(index) {
          if (self.recordingOpts.recordings[index] && self.recordingOpts.recordings[index].link) {
            self.recordingOpts.selected = index;
          }
        },
        parseRecordings: function(options) {
          self.recordingOpts.recordings = options.map(function(item) {
            item.recording_type = item.recording_type ? item.recording_type.replace(/_/g, " ") : '';
            return item;
          });
        },
        deleteRecording: function() {
          self.recordingOpts.loading = true;
          var updatedRecordings = $scope.instance.recordings.slice(0);
          updatedRecordings.splice(self.recordingOpts.selected, 1);

          WorkshopInstances.update({subresource: $scope.instance._id, fields: 'recordings'}, {recordings: updatedRecordings}).$promise
          .then(function(instance) {
            $scope.instance.recordings = instance.recordings;
            self.recordingOpts.loading = false;
            self.recordingOpts.selected = 0;
            self.recordingOpts.parseRecordings(instance.recordings || []);
            self.recordingOpts.deleteConfirmation = false;
            Application.messaging.addMessage({type: 'success', duration: 4, text: 'Recording deleted.'});
          });
        }
      };

      self.placeholder = {
        search: self.translations['workshopInstanceHost.search_placeholder'],
        notes: self.translations['workshopInstanceHost.add_workshop_notes']
      };

      self.sendPost = false;

      self.seeZoomHistory = function() {
        Application.navigation.goTo(`/host/workshop-instance/zoom-history/${$scope.instance._id}`);
      };

      self.allowZoomHistory = function() {
        return window.zoomsecret && self.info.isZoom;
      };

      self.info = {
        tab: '',
        notes: '',
        originalNotes: '',
        registrationDownload: '',
        waitlistDownload: '',
        registrationClicked: false,
        waitlistClicked: false,
        showPost: false,
        yearOld: false,
        aiEnabled: Application.features.flags().enable_generative_ai,
        isZoom: false,
        zoomType: '',
        pastDate: false,
        zoomLoading: false,
        syncZoom: async function () {
          if (!self.info.isZoom || !self.info.pastDate) {
            return;
          }
          self.info.zoomLoading = true;
          await ZoomIntegrate.manualParticipantSync({option: $scope.instance._id}, {}).$promise;
          self.info.zoomLoading = false;
          self.info.isZoom = false;
          
          self.info.getTotals(true);
          self.registrations.queryChange({workshop_instance: $scope.instance._id});
          self.registrations.displayClick();
          self.waiting.queryChange({workshop_instance: $scope.instance._id});
          self.registrations.selections = [];
          self.waiting.selections = [];
          Application.messaging.addMessage({status: 'success', duration: 7, text: 'Participant Sync Successful!'});
          $scope.$apply();
        },
        getZoomSummary: async function() {
          self.info.zoomSummaryLoading = true;

          if (!self.info.isZoom || !self.info.pastDate) {
            return;
          }
          let fullOriginalSummary;
          let editedSummary;

          const instance = await ZoomIntegrate.getZoomSummary({option: $scope.instance._id}).$promise;

          if (!instance?.zoom_summary || (!instance.zoom_summary?.edited_summary?.summary_details && !instance?.zoom_summary?.summary_details?.length)) {
            fullOriginalSummary = $scope.instance.zoom_summary;
            editedSummary = $scope.instance.zoom_summary?.edited_summary;
          } else {
            fullOriginalSummary = instance.zoom_summary;
            editedSummary = instance.zoom_summary.edited_summary;
          }
          if (!fullOriginalSummary?.summary_details?.length && !editedSummary?.summary_details?.length) {
            Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['manage.host.workshop.zoomAiError']});
            console.error('Error getting Zoom AI Summary');
            return;
          }
          
          /**
           * Example of zoom summary object.  
           * fullOriginalSummary is this object, editedSummary = zoom_summary.edited_summary
           * 
            zoom_summary: {
              summary_last_modified_time: "2024-05-13T18:46:14.000Z",
              summary_title: "Meeting Summary for Zoom Meeting",
              summary_overview: "This would be an overview provided by Zoom.  It can't be edited on Zoom.",
              summary_details: [
                {
                  label: "A Label Zoom has determined for this section of the summary",
                  summary: "A paragraph or so around the associated label.",
                },
              ],
              next_steps: ['Step One', 'Step Two', 'Step Three'],
              edited_summary: {
                summary_details:
                  "A full string of the edited summary\n\nPossibly with newlines",
                next_steps: [
                  "Edited Step One",
                  "Edited Step Two",
                ],
              },
            }
          */

          // only overwrite subject if they haven't intentionally added one
          if (self.postEmail.post_email_subject === '') {
            self.postEmail.post_email_subject = fullOriginalSummary.summary_title || '';
          }
          if (fullOriginalSummary.summary_overview) {
            // append so we don't lose any text admin may have already written
            self.postEmail.post_email_body += `${self.translations['manage.host.workshop.zoomAiEmailOverview']}<p>${fullOriginalSummary.summary_overview}</p>`;
          }

          // prioritize an edited summary over Zoom's original summary
          if (editedSummary?.summary_details?.length) {
            // edited summary will return full string of summary text in summary_details
            self.postEmail.post_email_body += `<p>${editedSummary.summary_details}</p>`;
            // Create unordered list of items in next_steps array, appending to end 
            if (editedSummary.next_steps.length) {
              let nextStepsString = `${self.translations['manage.host.workshop.zoomAiEmailNextSteps']}<ul>`;
              for (const step of editedSummary.next_steps) {
                nextStepsString += `<li>${step}</li>`;
              }
              self.postEmail.post_email_body += nextStepsString + '</ul>';
            }
          } else if (fullOriginalSummary.summary_details.length) {
            let summaryBody = '';
            // original summary returns array of objects [{label: 'text', summary: 'text}]
            // iterate and present these as headers and paragraphs
            for (const detail of fullOriginalSummary.summary_details) {
              summaryBody += `<h3>${detail.label}</h3><p>${detail.summary}</p>`;
            }
            self.postEmail.post_email_body += summaryBody;
            // Create unordered list of items in next_steps array, appending to end 
            if (fullOriginalSummary.next_steps.length) {
              let nextStepsString = `${self.translations['manage.host.workshop.zoomAiEmailNextSteps']}<ul>`;
              for (const step of fullOriginalSummary.next_steps) {
                nextStepsString += `<li>${step}</li>`;
              }
              self.postEmail.post_email_body += `${nextStepsString}</ul>`;
            }
          }
          self.info.zoomSummaryLoading = false;
          $scope.$apply();
        },
        changeTab: function(type) {
          this.tab = type;
          $scope.tab = type;
          self.regTabStatusToSet = self.statusToSet; // store as temporary value til we navigate back to 'registered'
          switch (type) {
            case 'registered':
              self.registrations.displayClick();
              self.statusToSet = self.regTabStatusToSet;
              return;
            case 'waitlist':
              self.waiting.displayClick();
              self.statusToSet = 'removed';
              return;
            default:
              return;
          }
        },
        getTotals: function(init) {
          self.info.totals = {
            registered: 0,
            waiting: 0,
            attended: 0,
            absentees: 0,
            availableSeats: 0
          };
          UserWorkshops.instanceTotals({userid: $scope.instance._id}).$promise
          .then(function(data) {
            self.info.totals = data;
            self.info.totals.availableSeats = $scope.instance.seats - self.info.totals.registered;
            self.info.totals.availableSeats = !self.info.totals.availableSeats || self.info.totals.availableSeats < 0 ? 0 : self.info.totals.availableSeats;
            self.info.totals._id = $scope.instance._id;
            self.postEmail.recipientCountUpdate();
            if (init) {
              return;
            }
            $scope.updateTotals({instanceData: self.info.totals});
          });
        },
        updateNotes: function() {
          self.info.notesLoading = true;
          WorkshopInstances.update({subresource: $scope.instance._id, fields: 'notes'}, {notes: self.info.notes}).$promise
          .then(function(instance) {
            $scope.instance.notes = instance.notes;
            self.info.notes = instance.notes;
            self.info.originalNotes = JSON.parse(JSON.stringify(self.info.notes));
            self.info.notesLoading = false;
            Application.messaging.addMessage({type: 'success', duration: 4, text: self.translations['workshopInstanceHost.notes_saved']});
          });
        },
        statusMap: {
          needsAction: 'Needs Action',
          declined: 'Declined',
          accepted: 'Accepted',
          tentative: 'Tentative'
        }
      };

      self.registrations = new TableData('$in,3,registered,attended,absent');
      self.waiting = new TableData('waiting');

      self.checkIns = {
        loading: false,
        alter: async function(item, type) {
          self.checkIns.loading = true;
          try {
            const results = await Workshops.updateRegistrationStatuses(
              {subresource: $scope.workshop._id, instanceId: $scope.instance._id},
              {user_ids: [item.user._id], status: type}
            ).$promise
            self.info.getTotals();
            item.active_status = results.active_status;
            self.checkIns.loading = false;
          } catch(error) {
            // handle error
            console.error('error in userWorkshop update', error);
            self.checkIns.loading = false;
          }
        }
      };

      self.toggleSelectAll = function() {
        if (!self.allSelected) {
          this.registrations.selectAll();
        } else {
          this.registrations.deselectAll();
        }
      }

      self.statusChanges = {
        show: false,
        loading: false,
        showResults: false,
        name: [],
        makeModal: function(type) {
          var data = type === 'registrations' ? self.registrations : self.waiting;
          this.names = [];
          if (!data.selections || !data.selections.length) {
            return;
          }

          data.selections.forEach(function(userid) {
            if (data.selectedItems[userid] && data.selectedItems[userid].user && data.selectedItems[userid].user.full_name) {
              self.statusChanges.names.push(data.selectedItems[userid].user.full_name)
            }
          });

          this.show = true;
        },
        updateRegistrationStatuses: async function() {
          let data = self.info.tab === 'registered' ? self.registrations : self.waiting;
          const userIds = [];
          data.selections.forEach(function(userId) {
            const userWorkshop = data.selectedItems[userId];
            const userWorkshopId = userWorkshop._id;
            if (userWorkshop && userWorkshopId) {
              userIds.push(userId);
            }
          });

          self.statusChanges.loading = true;
          try {
            const results = await Workshops.updateRegistrationStatuses(
              {subresource: $scope.workshop._id, instanceId: $scope.instance._id},
              {user_ids: userIds, status: self.statusToSet}
            ).$promise

            self.info.getTotals();
            self.statusChanges.results = {
              removed: [],
              errored: []
            };
            results.errored.forEach(function(item) {
              if (!item || !item.item) {
                return;
              }
              self.statusChanges.results.errored.push(data.selectedItems[item.item.user].user.full_name);
            });
            data.comms.query.page = 1;
            data.comms.load();
            data.deselectAll();
            self.statusChanges.show = false;
            self.statusChanges.loading = false;
            if (self.statusChanges.results.errored && self.statusChanges.results.errored.length) {
              self.statusChanges.showResults = true;
              return;
            }
            Application.messaging.addMessage({type: 'success', duration: 5, text: self.translations[`workshopInstanceHost.all_selected_users_${self.statusToSet}`]});
          } catch(error) {
            Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['workshopInstanceHost.error_updating_user_statuses']});
            console.error('error in multiple removals: ', error);
            self.statusChanges.show = false;
            self.statusChanges.loading = false;
          }
        },
        cancel: function() {
          this.names = [];
          this.show = false;
        }
      };

      self.assignments = {
        show: false,
        clear: false,
        startCancel: function() {
          this.show = !this.show;
          this.clear = true;
        },
        updateLists: function() {
          self.info.getTotals();
          var data = self.info.tab === 'registered' ? self.registrations : self.waiting;
          data.comms.query.page = 1;
          data.selections = [];
          data.selectedItems = {};
          data.comms.load();
        }
      };

      self.categories = {
        data: null,
        locations: {},
        departments: {},
        organize: function(cats) {
          this.data = cats;
          for (var i = 0; i < cats.length; i++) {
            if (cats[i].location) {
              self.categories.locations[cats[i]._id] = cats[i];
            }
            if (cats[i].department) {
              self.categories.departments[cats[i]._id] = cats[i];
            }
          }
        }
      };

      self.postEmail = {
        post_email_from: '',
        post_email_subject: '',
        post_email_body: '',
        include_registered: false,
        recipient_total: 0,
        loading: false,
        parse: function() {
          self.postEmail.recipient_total = 0;
          self.postEmail.post_email_from = '';
          self.postEmail.post_email_subject = '';
          self.postEmail.post_email_body = '';
          self.postEmail.include_registered = false;
          self.postEmail.recipientCountUpdate();

          if (!$scope.workshop || !$scope.workshop.post_messaging_options || !$scope.workshop.post_messaging_options.length) {
            return;
          }

          $scope.workshop.post_messaging_options.forEach(function(item) {
            if (item.name === 'post_email_from') {
              self.postEmail['post_email_from'] = item.value;
            }
            if (item.name === 'post_email_subject') {
              self.postEmail['post_email_subject'] = item.value;
            }
            if (item.name === 'post_email_body') {
              self.postEmail['post_email_body'] = item.value;
            }
          });
        },
        recipientCountUpdate: function() {
          self.postEmail.recipient_total = self.info.totals.attended;
          if (self.postEmail.include_registered) {
            self.postEmail.recipient_total = self.info.totals.registered;
          }
        },
        send: function(type) {
          if (!self.postEmail.recipient_total) {
            self.info.showPost = false;
            Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['workshopInstanceHost.no_email_recipients']});
            return;
          }

          if (!self.postEmail.post_email_from || !self.postEmail.post_email_subject || !self.postEmail.post_email_body) {
            Application.messaging.addMessage({type: 'error', duration: 6, text: self.translations['workshopInstanceHost.fill_email_fields']});
            return;
          };

          var body = {
            post_email_from: self.postEmail.post_email_from,
            post_email_subject: self.postEmail.post_email_subject,
            post_email_body: self.postEmail.post_email_body,
            include_registered: self.postEmail.include_registered,
            recipient_total: self.postEmail.recipient_total
          };

          self.postEmail.loading = true;
          UserWorkshops.postEmail({useropt: $scope.instance._id}, body).$promise
          .then(function(results) {
            self.postEmail.loading = false;
            Application.messaging.addMessage({type: 'success', duration: 5, text: self.translations['workshopInstanceHost.email_sent']});
            $scope.instance.post_message_sent = true;
            self.info.showPost = false;
          }).catch(function(error) {

          });
        }
      };

      Categories.find({
        $or: '4,location,true,department,true',
        sort: 'name,1'
      }).$promise.then(function(data) {
        self.categories.organize(data);
      }).catch(function(error) {
        // handle error
        console.log('error in getting categories: ', error)
      });

      // Init when instance changes check for instance on start
      $scope.$watch('instance', function(newVal, oldVal) {
        if (!newVal || !newVal._id || newVal === oldVal || (oldVal._id && newVal._id === oldVal._id)) {
          return;
        }

        if ($scope.instance.recordings && $scope.instance.recordings[0] && $scope.instance.recordings[0].link) {
          self.recordingOpts.show = true;
          self.recordingOpts.parseRecordings($scope.instance.recordings);
        }

        self.allowRating = $scope && $scope.rating_configuration && $scope.rating_configuration.allow_rating;
        if (self.allowRating && $scope.instance.average_rating) {
          var outOfFive = Math.round($scope.instance.average_rating * 5) / 100;
          if (outOfFive) {
            self.rating = outOfFive;
          }
        }

        self.info.getTotals(true);
        self.info.isZoom = false;
        self.info.pastDate = false;
        self.info.yearOld = false;
        if ($scope.instance.zoom_settings && $scope.instance.zoom_settings.post_uuid) {
          self.info.isZoom = true;
          self.info.zoomType = $scope.instance.zoom_settings.meeting_type;
        }
        const endDate = new Date($scope.instance.end_date);
        const oneYearAgo = new Date().setFullYear(new Date().getFullYear() - 1);
        if (endDate < new Date()) {
          self.info.pastDate = true;
        }
        if (oneYearAgo > endDate) {
          self.info.yearOld = true;
        }

        self.info.registrationDownload = Application.API + '/learn/v3/user-workshops/workshop-instance/' + $scope.instance._id + '/registration-csv?authtoken=' + Authorization.getAuthToken().authtoken;
        self.info.waitlistDownload = Application.API + '/learn/v3/user-workshops/workshop-instance/' + $scope.instance._id + '/waitlist-csv?authtoken=' + Authorization.getAuthToken().authtoken;
        self.info.tab = 'registered';
        $scope.tab = 'registered';
        self.info.notes = $scope.instance.notes ? JSON.parse(JSON.stringify($scope.instance.notes)) : '';
        self.info.originalNotes = self.info.notes;
        self.registrations.queryChange({workshop_instance: $scope.instance._id});
        self.registrations.displayClick();
        self.waiting.queryChange({workshop_instance: $scope.instance._id});
        self.registrations.selections = [];
        self.waiting.selections = [];
        self.postEmail.parse();
        self.gcalAttendees = {};
        self.showGcal = false;
        WorkshopInstances.getWithGcal({group: $scope.instance._id, fields: 'google_calendar_entity'}).$promise
        .then(function(results) {
          var instance = results.workshop_instance;
          if (instance.google_calendar_entity && results.gcal_attendees) {
            self.showGcal = true;
            results.gcal_attendees.forEach(function(item) {
              if (item.email) {
                self.gcalAttendees[item.email] = item.responseStatus;
              }
            });
          }
        })
      });

      $scope.$watch('triggerAdd', function(newVal, oldVal) {
        if (newVal !== oldVal && (newVal || oldVal)) {
          self.assignments.startCancel();
        }
      });

      $scope.$watch('triggerWait', function(newVal, oldVal) {
        if (newVal !== oldVal && (newVal || oldVal)) {
          self.assignments.startCancel();
        }
      });

      $translate([
        'workshopInstanceHost.search_placeholder',
        'workshopInstanceHost.add_workshop_notes',
        'workshopInstanceHost.notes_saved',
        'workshopInstanceHost.all_selected_users_removed',
        'workshopInstanceHost.all_selected_users_attended',
        'workshopInstanceHost.all_selected_users_absent',
        'workshopInstanceHost.all_selected_users_registered',
        'workshopInstanceHost.error_updating_user_statuses',
        'workshopInstanceHost.no_email_recipients',
        'workshopInstanceHost.fill_email_fields',
        'workshopInstanceHost.email_sent',
        "manage.host.workshop.markRegistered",
        "manage.host.workshop.markAttended",
        "manage.host.workshop.markAbsent",
        "manage.host.workshop.markRemoved",
        "workshop.status.attended",
        "workshop.status.absent",
        "workshop.status.registered",
        "workshop.status.removed",
        "manage.host.workshop.zoomAiEmailOverview",
        "manage.host.workshop.zoomAiEmailNextSteps",
        "manage.host.workshop.zoomAiError"
      ]).then(function (translations) {
        self.translations = translations;
        self.registrationStatusActions = [
          {value: 'registered', name: self.translations["manage.host.workshop.markRegistered"]},
          {value: 'attended', name: self.translations["manage.host.workshop.markAttended"]},
          {value: 'absent', name: self.translations["manage.host.workshop.markAbsent"]},
          {value: 'removed', name: self.translations["manage.host.workshop.markRemoved"]}
        ]
        self.registrationStatuses = {
          registered: self.translations["workshop.status.registered"].toString(),
          attended: self.translations["workshop.status.attended"].toString(),
          absent: self.translations["workshop.status.absent"].toString(),
          removed: self.translations["workshop.status.removed"].toString()
        }
      });

    }],
    controllerAs: 'participation'
  }
}]);